import { Component, Input } from '@angular/core';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-marketing-material-card',
  templateUrl: './marketing-material-card.component.html',
  styleUrls: ['./marketing-material-card.component.less']
})
export class MarketingMaterialCardComponent {
  @Input() data: any;
  isTargetVisible = false;
  isAttachmentVisible = false;

  items = [
    { name: '标准型火花塞', qty: 8 },
    { name: '标准型火花塞', qty: 8 },
    { name: '标准型火花塞', qty: 3 },
    { name: '标准型火花塞', qty: 8 }
  ];

  getColorByStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "审批中":
        color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
        break;
      case "审批通过":
        color = isBackground ? "#F1F8F7" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }

  formatMoney(value: any, decimals = 2): string {
    if (value === null || value === undefined || value === '' || value === 0) {
      return '-';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    return num
      .toFixed(decimals)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  handleOpenModal(): void {
    this.isAttachmentVisible = true;
  }

  handleCancel(): void {
    this.isAttachmentVisible = false;
  }

  getColorByApprovalStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "审批中":
        color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
        break;
      case "审批拒绝":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "审批通过":
        color = isBackground ? "#F1F8F7" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      case "撤回":
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }

  getFilenameFromUrl(url: string): string {
    if (!url) return '';
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.pathname.split('/').pop() || '';
    } catch {
      return url.split('/').pop() || '';
    }
  }

  isAttachmentExist() {
    const fields = [
      'salesTargetScreenshot',
    ];

    return fields.some(key => {
      const value = this.data?.[key];
      return Array.isArray(value) && value.length > 0;
    });
  }

  onViewClick() {
    this.isTargetVisible = true;
  }

  handleCancelView() {
    this.isTargetVisible = false;
  }

  formatDisplayDate(
    value: any,
    pattern: string = 'yyyy.MM.dd',
    locale: string = 'en-US',
    placeholder: string = '--'
  ): string {
    if (!value || value === placeholder) return placeholder;

    // 尝试转换为 Date 对象
    const date = new Date(value);
    if (isNaN(date.getTime())) return placeholder;

    try {
      return formatDate(date, pattern, locale);
    } catch {
      return placeholder;
    }
  }
}
